import React from 'react'
import Title from './Title/Title';
import books from "../assets/images/books.png";
import quiz from "../assets/images/brain.png";
import podcast from "../assets/images/podcast.png";

const GoldFeatures = () => {
    return (
        <section className="gold-app-features">
            <div className="container ">
                <Title title="Array of Educational Feature" />
                <div className="section-para text-center pb-3 wid-50 mx-auto">
                    <p className="feature-desc-head">
                        Offering an array of premium educational features designed to
                        empower kids with essential money management skills. With Good
                        Good Piggy Gold, learning about finance becomes an engaging
                        adventure, guiding children towards financial literacy in a fun
                        and interactive way.
                    </p>
                </div>
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                        <div className="card feature-card text-center">
                            <div>
                                <img
                                    src={books}
                                    alt="Digital Storybooks"
                                    className="img-fluid app-feature-image"
                                />
                            </div>
                            <div className="card-body p-3">
                                <h2 className="feature-name">Digital Storybooks</h2>
                                <p className="text-center feature-desc">
                                    Immerse yourself in a world of storytelling that combines
                                    entertainment with financial education. Explore diverse
                                    narratives that teach important concepts like earning,
                                    spending, and making wise financial choices.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                        <div className="card feature-card text-center">
                            <div className="service-image-div">
                                <img
                                    src={quiz}
                                    alt="Money Maths Quiz"
                                    className="img-fluid app-feature-image"
                                />
                            </div>
                            <div className="card-body p-3">
                                <h2 className="feature-name">Money Maths Quiz</h2>
                                <p className="text-center feature-desc">
                                    Challenge yourself with fun and interactive quizzes that
                                    sharpen your math skills while teaching you about money.
                                    From basic arithmetic to advanced concepts, our quizzes make
                                    learning finance exciting!
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-12 mb-4">
                        <div className="card feature-card text-center">
                            <div className="service-image-div">
                                <img
                                    src={podcast}
                                    alt="Podcast for Kids"
                                    className="img-fluid app-feature-image"
                                />
                            </div>
                            <div className="card-body p-3">
                                <h2 className="feature-name">
                                    Podcast for Kids on Money Management
                                </h2>
                                <p className="text-center feature-desc">
                                    Listen to captivating stories while learning valuable
                                    lessons about money. Our bite sized podcast series is
                                    designed to entertain and educate young listeners on topics
                                    like saving, budgeting, and smart spending.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default GoldFeatures